import { LayoutDashboard, Users, BookOpen, Copy } from "lucide-react";

export const NAV_ITEMS = [
  { to: "/", label: "Dashboard", pt: "Dashboard", icon: LayoutDashboard, id: "dashboard" },
  { to: "/users", label: "Users", pt: "Utilizadores", icon: Users, id: "users" },
  { to: "/questions", label: "Questions", pt: "Perguntas", icon: BookOpen, id: "questions" },
  { to: "/duplicates", label: "Duplicates", pt: "Duplicados", icon: Copy, id: "duplicates" },
];
